import { render } from "./EditConfigTemplate.vue?vue&type=template&id=5a717914"
import script from "./EditConfigTemplate.vue?vue&type=script&lang=js"
export * from "./EditConfigTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__